module.exports = __webpack_public_path__ + "img/若依开国大典场景图.8323d8c3.png";